import { NgModule } from '@angular/core';
import { CommonNavigationModule } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { isTablet } from '@capital-access/emails/common';
import { EMAILS_PATH } from './constants';

export const loadModule = () => import('@capital-access/emails/client').then(m => m.EmailsClientModule);
export const loadUnsubscribeModule = () =>
  import('@capital-access/emails/unsubscribe').then(m => m.EmailsUnsubscribeModule);

// @dynamic
@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: EMAILS_PATH,
          loadChildren: loadModule
        }
      ],
      anonymous: [
        {
          path: 'emails/unsubscribe',
          data: { navigation: false }, // do not show top-nav for landing pages
          loadChildren: loadUnsubscribeModule
        }
      ]
    }),
    CommonNavigationModule.forFeature({
      top: [
        {
          localizationKey: 'mail',
          icon: 'f-i-email',
          order: 500,
          link: EMAILS_PATH,
          enabled: !isTablet()
        }
      ]
    })
  ]
})
export class EmailsClientLazyModule {}
